export const PARTNER_REVISION_LABEL = 'Partner Revision';

export const GRAPHICS_QA_STATUS_SEQUENCE = [
  'All',
  'New',
  'Internal Revision',
  'Internal Approved',
  'Sent for Approval',
  'Approved',
  'Paused',
  PARTNER_REVISION_LABEL,
  'Moved to Assets Gallery',
];

export const matchesGraphicsQAStatus = (statusText, filterText) => {
  if (filterText === 'All') return true;
  const text = (statusText || '').trim();
  if (filterText === PARTNER_REVISION_LABEL) {
    return text === 'Re-Work' || text === PARTNER_REVISION_LABEL;
  }
  return text.toLowerCase() === filterText.toLowerCase();
};

export const getGraphicsQAStatusCount = (statusCountMap, filterText, total) => {
  if (filterText === 'All') {
    return total != null
      ? total
      : Object.values(statusCountMap || {}).reduce((sum, count) => sum + count, 0);
  }
  if (filterText === PARTNER_REVISION_LABEL) {
    return (
      ((statusCountMap && statusCountMap['Re-Work']) || 0) +
      ((statusCountMap && statusCountMap[PARTNER_REVISION_LABEL]) || 0)
    );
  }
  return (statusCountMap && statusCountMap[filterText]) || 0;
};

export const getGraphicsQAStatusColorKey = (displayText) =>
  displayText === PARTNER_REVISION_LABEL ? 'Re-Work' : displayText;
